// extracted by mini-css-extract-plugin
module.exports = {"formExplain":"FormExplain_formExplain__PR_U0"};